import { createApi } from '@reduxjs/toolkit/query/react'
import { authenticatedBaseQuery } from './baseQuery'

export const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery: authenticatedBaseQuery,
  tagTypes: ['Coupon'],
  endpoints: (builder) => ({
    getAllCoupons: builder.query({
      query: () => 'order/coupons/',
      providesTags: ['Coupon'],
    }),
    createCoupon: builder.mutation({
      query: (data) => ({
        url: 'order/coupons/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Coupon'],
    }),
    updateCoupon: builder.mutation({
      query: ({ data, id }) => ({
        url: `order/coupons/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Coupon'],
    }),
    deleteCoupon: builder.mutation({
      query: (id) => ({
        url: `order/coupons/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Coupon'],
    }),
  }),
})

export const {
  useGetAllCouponsQuery,
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
} = couponApi
